export enum MessageEvents {
  BANDWIDTH_PHONE_NUMBER_LOOKUP = 'BANDWIDTH_PHONE_NUMBER_LOOKUP',
  CONVERT_CHANNEL_MESSAGE_ATTACHMENT_TO_MP4 = 'CONVERT_CHANNEL_MESSAGE_ATTACHMENT_TO_MP4',
}
